// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/occupancy_limits.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_money } from "../../core/money_pb";

/**
 * Describes the file proto/model/feature/hotel/occupancy_limits.proto.
 */
export const file_proto_model_feature_hotel_occupancy_limits = /*@__PURE__*/
  fileDesc("CjBwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL29jY3VwYW5jeV9saW1pdHMucHJvdG8SBmNhcm1lbiKeAQoPT2NjdXBhbmN5TGltaXRzEhIKCm1heF9hZHVsdHMYASABKAUSFAoMbWF4X2NoaWxkcmVuGAIgASgFEhEKCW1heF90b3RhbBgDIAEoBRImCg9leHRyYV9hZHVsdF9mZWUYBCABKAsyDS5jYXJtZW4uTW9uZXkSJgoPZXh0cmFfY2hpbGRfZmVlGAUgASgLMg0uY2FybWVuLk1vbmV5QjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw", [file_proto_model_core_money]);

/**
 * Describes the message carmen.OccupancyLimits.
 * Use `create(OccupancyLimitsSchema)` to create a new message.
 */
export const OccupancyLimitsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_occupancy_limits, 0);

